import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { IconButton, Stack } from "@mui/material";
import isEmpty from "lodash/isEmpty";
import { memo, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import type { CustomerListItem } from "../../customers/customersApi";
import type { Calculation } from "../calculation";
import { customerSelectSx } from "../components/customerSelectSx";
import CustomerSelect from "../../components/customerSelect/CustomerSelect";

export const CustomerSection = memo(function CustomerSection({
  defaultValue,
  onChange,
  disabled,
}: {
  defaultValue: Calculation["customer"];
  onChange(customer: CustomerListItem | null): void;
  disabled?: boolean;
}) {
  const [customer, setCustomer] = useState(defaultValue);
  function handleChange(customer: CustomerListItem | null) {
    setCustomer(customer);
    onChange(customer);
  }
  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{
        alignItems: "center",
      }}
    >
      <CustomerSelect
        customerId={customer?.id ?? null}
        onChange={(_, customer) => handleChange(customer)}
        disabled={disabled}
        required
        size="medium"
        sx={customerSelectSx}
      />
      <IconButton
        component={RouterLink}
        color="primary"
        disabled={isEmpty(customer?.id)}
        to={`/customers/${customer?.id}`}
        target="_blank"
        title="Otwórz kartę klienta w nowym oknie"
      >
        <OpenInNewIcon />
      </IconButton>
    </Stack>
  );
});
